'use client';

import Link from 'next/link';

import { buttonVariants } from '@/components/ui/button';

import { COPY } from '@/shared/constants/copies';
import { APP_ENVS } from '@/shared/constants/envs';
import { APP_ROUTES } from '@/shared/constants/navigation';

import { cn } from '@/lib/utils';

import { SWITCH_MAILTO, SWITCH_MIGRATION_HOURS } from '../../constants/switch-content';
import { MARKETING_PAGE, trackGetStartedClicked } from '../../utils/marketing-analytics';

/**
 * /switch hero. Unlike the other SEO heroes this one keeps two CTAs in the
 * first fold: the page exists to convert a visitor who has already decided to
 * move. Sign-up leads; the mailto is for someone who wants to talk first.
 */
export const SwitchHeroSection = () => {
	return (
		<section className="landing-width mb-12 flex w-full flex-col items-center px-4 text-center md:mb-16 md:px-8">
			<h1 className="landing-heading mt-8 w-full text-balance !bg-none !text-[32px] !text-primary tracking-tight md:mt-0 md:!text-[48px]">
				Switch your ATS. Your remaining months are on us.
			</h1>

			<p className="mt-5 max-w-3xl text-pretty text-base leading-relaxed text-[hsl(215_20%_38%)] md:mt-6 md:max-w-xl md:text-[1.375rem] md:leading-8">
				Move to {APP_ENVS.COMPANY_NAME} from any applicant tracking system. We migrate your jobs,
				candidates and history in {SWITCH_MIGRATION_HOURS} hours, and the months left on your current
				contract become free months on any {APP_ENVS.COMPANY_NAME} annual plan.
			</p>

			<div className="mt-8 flex w-full flex-wrap items-center justify-center gap-3">
				<Link
					href={APP_ROUTES.LOGIN}
					className={cn(
						buttonVariants(),
						'h-[48px] w-full px-5 text-base tracking-wide shadow-[0px_8px_10px_0px_#3C424C3D] transition-all hover:translate-y-0.5 sm:w-auto'
					)}
					onClick={() => trackGetStartedClicked(MARKETING_PAGE.SWITCH, 'hero')}
				>
					Start for free
				</Link>
				<a
					href={SWITCH_MAILTO}
					className={cn(
						buttonVariants({ variant: 'light' }),
						'h-[48px] w-full px-5 text-base tracking-wide sm:w-auto'
					)}
				>
					{COPY.pricing.switchTalkToUsCta}
				</a>
			</div>

			<p className="mt-4 text-sm text-secondary">Start on your own or talk to us first. Either way, you never pay for two tools.</p>
		</section>
	);
};
